// JsFromRoutes CacheKey 5157c1956512cb82dc87da7506b4c9f8
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from "@js-from-routes/axios";

export const holidayLeaveResponses = {
  create: definePathHelper("post", "/holiday_leave_responses"),
  new: definePathHelper("get", "/holiday_leave_responses/new"),
  hostingRooms: definePathHelper("get", "/holiday_leave_responses/hosting_rooms"),
  hosts: definePathHelper("get", "/holiday_leave_responses/hosts"),
};
